var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1800_4257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2578 33.9336H13.813C12.9036 33.9336 12.1638 33.1938 12.1638 32.2843V20.0033H8.98715C8.0777 20.0033 7.33789 19.2633 7.33789 18.3541V13.0916C7.33789 12.1822 8.0777 11.4424 8.98715 11.4424H12.1638V8.80713C12.1638 6.1942 12.9842 3.97115 14.5362 2.37869C16.0952 0.778977 18.2739 -0.0664062 20.8368 -0.0664062L24.9892 -0.0596619C25.8971 -0.0581055 26.6357 0.681702 26.6357 1.5896V6.47565C26.6357 7.3851 25.8961 8.12491 24.9869 8.12491L22.1911 8.12595C21.3385 8.12595 21.1213 8.29689 21.0749 8.34929C20.9984 8.43619 20.9073 8.68184 20.9073 9.36017V11.4421H24.7768C25.0681 11.4421 25.3503 11.514 25.5929 11.6494C26.1161 11.9417 26.4414 12.4945 26.4414 13.0919L26.4393 18.3543C26.4393 19.2633 25.6995 20.0031 24.79 20.0031H20.9073V32.2843C20.9073 33.1938 20.1673 33.9336 19.2578 33.9336ZM14.157 31.9404H18.9138V19.111C18.9138 18.5037 19.408 18.0098 20.015 18.0098H24.4461L24.4479 13.4356H20.0147C19.4077 13.4356 18.9138 12.9417 18.9138 12.3344V9.36017C18.9138 8.58145 18.993 7.69586 19.5808 7.03024C20.291 6.22559 21.4103 6.13272 22.1906 6.13272L24.6424 6.13168V1.93304L20.8352 1.92682C16.7165 1.92682 14.157 4.56335 14.157 8.80713V12.3344C14.157 12.9414 13.6631 13.4356 13.0561 13.4356H9.33112V18.0098H13.0561C13.6631 18.0098 14.157 18.5037 14.157 19.111V31.9404Z",
    fill: "#844C0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1800_4257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.9336,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookicon);
export default __webpack_public_path__ + "static/media/facebookicon.add85a8faf7d99dde3cc3d7204fd51f3.svg";
export { ForwardRef as ReactComponent };